{
  "key": "federation-drive-hobby-farm",
  "title": "Federation Drive hobby farm",
  "suburb": "Federation Drive",
  "locationGroup": "rural",
  "grassType": "kikuyu",
  "cellM": 1.5,
  "gameScale": 3,
  "w": 80,
  "h": 60,
  "rows": [
    "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggbbbggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "eggg..............gggggoooooogggggggggggggggggggggggggggggggggggggggggggggggggge",
    "eggg..............gggggoooooogggggggggggggggggggggggggggggggggggggggggggggggggge",
    "eggg..............ggoggoooooogggggggggGGGGgggggggggggggggggggggGGGGGGgggggggggge",
    "eggg..............gooogooooooggggggggGGGGGGgggggggggggggggggggGGGGGGGGggggggggge",
    "eggg..............ggoggoooooogggggggGGGGGGGGgggggggggggggggggGGGGGGGGGGgggggggge",
    "eggg..............gggggoooooogggggggGGGGGGGGgggggggggggggggggGGGGGGGGGGgggggggge",
    "eggg..............gggggggggggggggggggGGGGGGgggggggggggggggggggGGGGGGGGggggggggge",
    "eggg..............ggggggggggggggggggggGGGGgggggggggggggggggggggGGGGGGgggggggggge",
    "eggg..............ggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "eggg..............ggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "eggggggggggggggggpppppppppggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "eggggggggggggggggpppppppppggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "eggggggggggggggggpppppppppggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "eggggggggggggggggpppppppppggggggggggggggggggggwwwwwwwwggggggggggggggggggggggggge",
    "eggggggggggggggggpppppppppggggggggggggggggggwwwwwwwwwwwwggggggggggggggggggggggge",
    "eggggggggggggggggppggggggggggggggggggggggggwwwwwwwwwwwwwwgggggggggggggggggggggge",
    "eggggggggggggggggppgggggggggggggggggggggggwwwwwwwwwwwwwwwwggggggggggggggggggggge",
    "pppppppppppppppppppggggggggggggggggggggggwwwwwwwwwwwwwwwwwwgggggggggggogggggggge",
    "pppppppppppppppppppggggggggggggggggggggggwwwwwwwwwwwwwwwwwwgggggggggggggggggggge",
    "eggggggggggggggggggggggggggggggggggggggggwwwwwwwwwwwwwwwwwwgggggggggggggggggggge",
    "eggggggggggggggggggggggggggggggggggggggggwwwwwwwwwwwwwwwwwwgggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggwwwwwwwwwwwwwwwwggggggggggggggggggggge",
    "eggggggggggggggggggggggggggggggggggggggggggwwwwwwwwwwwwwwgggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggogggggggggggggwwwwwwwwwwwwggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggwwwwwwwwggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggogggggggggggggggggggggggggggggggggggggggggggggggggggggogggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggGGGGggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggGGGGGGGGgggggggggggggggggggggggggggggggggggggggggbbbbgggggggggggggggggge",
    "eggggggGGGGGGGGGGgggggggggggggggggggggggggggogggggggggeeeeeeeeeeeeeeeeeeeeeeeeee",
    "eggggggGGGGGGGGGGggggggggggggggggggggggggggggggggggggge........................e",
    "eggggggGGGGGGGGGGggggggggggggggggggggggggggggggggggggge........................e",
    "eggggggGGGGGGGGGGggggggggggggggggggggggggggggggggggggge........................e",
    "egggggggGGGGGGGGgggggggggggggggGGGGGGggggggggggggggggge........................e",
    "egggggggggGGGGgggggggggggggggGGGGGGGGGGggggggggggggggge........................e",
    "egggggggggggggggggggggggogggGGGGGGGGGGGGgggggggggggggge........................e",
    "egggggggggggggggggggggggggggGGGGGGGGGGGGgggggggggggggge........................e",
    "egggggggggggggggggggggggggggGGGGGGGGGGGGgggggggggggggge........................e",
    "egggggggggggggggggggggggggggGGGGGGGGGGGGgggggggggggggge........................e",
    "eggggggggggggggggggggggggggggGGGGGGGGGGggggggggggggggge........................e",
    "eggggggggggggggggggggggggggggggGGGGGGggggggggggggggggge........................e",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggge........................e",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggge........................e",
    "egggggggggggggggogggggggggggggggggggoggggggggggggggggge........................e",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggge........................e",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggge........................e",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggge........................e",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggge........................e",
    "egggggggggggbbgggggggggggggggggggggggggggggggggggggggge........................e",
    "eggggggggggbbbbggggggggggggggggggggggggggggggggggggggge........................e",
    "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
  ],
  "zoneRows": [
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "..............................................DDDDDDDD..........................",
    "............................................DDDDDDDDDDDD........................",
    "..........................................DDDD........DDDD......................",
    ".........................................DDD............DDD.....................",
    "........................................DDD..............DDD....................",
    "........................................DD................DD....................",
    ".......................................DD..................DD...................",
    ".......................................DD..................DD...................",
    ".......................................DD..................DD...................",
    ".......................................DD..................DD...................",
    "........................................DD................DD....................",
    "........................................DDD..............DDD....................",
    ".........................................DDD............DDD.....................",
    "..........................................DDDD........DDDD......................",
    "............................................DDDDDDDDDDDD........................",
    "..............................................DDDDDDDD..........................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................",
    "................................................................................"
  ],
  "zones": [
    {"id":"dam-edge","doNotMow":true,"penalty":false}
  ],
  "rangeMm": [60,90],
  "startLengthMm": [110,170],
  "props": [
    {"id":"water-tank-1","kind":"water-tank","x":30.75,"y":9.75,"r":1.8,"solid":true},
    {"id":"shed-1","kind":"shed","x":39,"y":9,"w":9,"h":7.5,"solid":true,"sprite":"machinery-shed"},
    {"id":"sheep-1","kind":"sheep","x":90.75,"y":68.88,"r":0.6,"rot":4.15,"solid":true},
    {"id":"sheep-2","kind":"sheep","x":100.2,"y":75.69,"r":0.6,"rot":2.69,"solid":true},
    {"id":"sheep-3","kind":"sheep","x":108.3,"y":64.63,"r":0.6,"rot":0.2,"solid":true},
    {"id":"gum-tree-1","kind":"gum-tree","x":12.75,"y":45.75,"r":0.7,"solid":true,"canopyR":5.6},
    {"id":"gum-tree-2","kind":"gum-tree","x":45.75,"y":39.75,"r":0.7,"solid":true,"canopyR":5.6},
    {"id":"gum-tree-3","kind":"gum-tree","x":54.75,"y":78.75,"r":0.7,"solid":true,"canopyR":5.6},
    {"id":"gum-tree-4","kind":"gum-tree","x":105.75,"y":30.75,"r":0.7,"solid":true,"canopyR":5.6},
    {"id":"gum-tree-5","kind":"gum-tree","x":93.75,"y":45.75,"r":0.7,"solid":true,"canopyR":5.6},
    {"id":"gum-tree-6","kind":"gum-tree","x":36.75,"y":66.75,"r":0.7,"solid":true,"canopyR":5.6},
    {"id":"rock-1","kind":"rock","x":66.75,"y":57.75,"r":0.9,"solid":true},
    {"id":"rock-2","kind":"rock","x":24.75,"y":78.75,"r":0.7,"solid":true},
    {"id":"rock-3","kind":"rock","x":45.75,"y":60.75,"r":0.3,"solid":false},
    {"id":"rock-4","kind":"rock","x":60.75,"y":45.75,"r":0.25,"solid":false},
    {"id":"letterbox-1","kind":"letterbox","x":1.35,"y":29.1,"w":0.4,"h":0.3,"solid":true}
  ],
  "spawn": {"x":32.25,"y":23.25,"heading":1.5707963267948966},
  "utePark": {"x":30,"y":21.75,"heading":0},
  "weedFraction": 0.3,
  "leaves": {"count":[150,300],"areas":[{"x":6,"y":39,"w":13.5,"h":13.5},{"x":39,"y":33,"w":13.5,"h":13.5},{"x":48,"y":72,"w":13.5,"h":13.5},{"x":99,"y":24,"w":13.5,"h":13.5},{"x":87,"y":39,"w":13.5,"h":13.5},{"x":30,"y":60,"w":13.5,"h":13.5}]},
  "camera": {"fit":"follow","allowLandscape":true},
  "mutations": ["magpie-season","bindii","heavy-leaves","ibis","hot-day"],
  "slope": {"x":0.12,"y":0.16}
}
